const { BACKEND_URL, API_KEY } = process.env;

if (!BACKEND_URL) throw new Error("BACKEND_URL env var not defined.");
if (!API_KEY) throw new Error("API_KEY env var not defined.");

export async function fetchFilterData() {
  try {
    const response = await fetch(BACKEND_URL!, {
      method: "GET",
      headers: { "Content-Type": "application/json" },
    });

    if (!response.ok) throw new Error(`HTTP error! Status: ${response.status}`);

    const data = await response.json();
    console.log("Data received:", data);
    return data;
  } catch (error) {
    console.error("Error fetching data:", error);
  }
}

export async function postFilterData(data: any) {
  try {
    const response = await fetch(BACKEND_URL!, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Basic " + btoa(API_KEY! + ":"),
      },
      body: JSON.stringify(data),
    });

    if (!response.ok) throw new Error(`HTTP error! Status: ${response.status}`);

    const responseData = await response.json();
    console.log("Data successfully posted:", responseData);
  } catch (error) {
    console.error("Error posting data:", error);
  }
}
